var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemCheckDeliveryFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3 3a1 1 0 0 0 0 2h5.5a.75.75 0 0 1 0 1.5H4a1 1 0 0 0 0 2h4.5a.75.75 0 0 1 0 1.5H3a1 1 0 1 0 0 2h2.5a.75.75 0 0 1 0 1.5H5a1 1 0 0 0-1 1v4c0 1.062.628 1.73 1.275 2.08.603.326 1.28.42 1.725.42h11c1.126 0 1.926-.491 2.412-1.166.448-.623.588-1.34.588-1.834V6c0-1.126-.491-1.926-1.166-2.412A3.23 3.23 0 0 0 18 3H3m10 10.586 3.086-4A.999.999 0 1 1 17.5 11l-3.793 4.707a.997.997 0 0 1-1.414 0L10 13.414A.999.999 0 1 1 11.414 12z",
  clipRule: "evenodd"
})));
export default SvgGemCheckDeliveryFilled;